export const LOADING = 'LOADING'; // 読込中
export const UPDATE_LOADING = 'UPDATE_LOADING'; // 読込中
export const SCROLL_LOADING = 'SCROLL_LOADING'; // スクロールした時
export const LOADED = 'LOADED'; // API取得後
export const ERROR = 'ERROR'; // エラー時
export const ERROR_COMMON = 'ERROR_COMMON'; // エラー時

/** コントロール部リスト */
export const LOADED_KUBUN = 'LOADED_KUBUN'; // 区分読み込み
export const LOADED_SHUBETSU = 'LOADED_SHUBETSU'; // 種別読み込み
export const LOADED_RATE = 'LOADED_RATE'; // レート読み込み
export const LOADED_MAKER = 'LOADED_MAKER'; // メーカー読み込み
export const LOADED_TYPE = 'LOADED_TYPE'; // タイプ読み込み
export const LOADED_KISHUNAME = 'LOADED_KISHUNAME'; // 機種名読み込み
export const LOADED_KIKAN = 'LOADED_KIKAN'; // 期間読み込み
export const LOADED_KIKAN_HEAD = 'LOADED_KIKAN_HEAD'; // 期間読み込み
export const LOADED_KAISHIBI = 'LOADED_KAISHIBI'; // 納品開始日初期値読み込み
export const LOADED_GOUKI = 'LOADED_GOUKI'; // 号機読み込み
export const LOADED_YUGI_TYPE = 'LOADED_YUGI_TYPE';//遊技タイプ読み込み

export const CHANGE_YUGI_TYPE = 'CHANGE_YUGI_TYPE';//遊技タイプ変更時
export const CHANGE_KUBUN = 'CHANGE_KUBUN'; // 区分変更時
export const CHANGE_SHUBETSU = 'CHANGE_SHUBETSU'; // 種別変更時
export const CHANGE_RATE = 'CHANGE_RATE'; // レート変更時
export const CHANGE_MAKER = 'CHANGE_MAKER'; // メーカー変更時
export const CHANGE_TYPE = 'CHANGE_TYPE'; // タイプ変更時
export const CHANGE_KISHUMEI = 'CHANGE_KISHUMEI'; // 機種名変更時
export const CHANGE_PSKUBUN = 'CHANGE_PSKUBUN'; // PS区分変更時
export const CHANGE_DAY = 'CHANGE_DAY'; // 平日休日変更時
export const CHANGE_KIKAN = 'CHANGE_KIKAN'; // 期間変更時
export const CHANGE_KAISHIBI = 'CHANGE_KAISHIBI'; // 納品開始日変更時
export const CHANGE_KAISHIBI_FROM = 'CHANGE_KAISHIBI_FROM'; // 納品開始日From変更時
export const CHANGE_KAISHIBI_TO = 'CHANGE_KAISHIBI_TO'; // 納品開始日To変更時
export const CHANGE_GOUKI = 'CHANGE_GOUKI'; // 号機変更時
export const CHANGE_SMARTYUGIKI = 'CHANGE_SMARTYUGIKI'; // スマート遊技機変更時
export const CHANGE_DISPLAY_FORMAT = 'CHANGE_DISPLAY_FORMAT'; // 表示形式変更時
export const CLICK_CSV = 'CLICK_CSV'; // CSV出力
export const CLEAR_KISHU = 'CLEAR_KISHU'; // 機種名検索クリア時
export const CHANGE_KISHU = 'CHANGE_KISHU'; // 機種名のonChange時
export const CLICK_SEARCH = 'CLICK_SEARCH'; // 検索ボタン押下時
export const CLICK_UPDATE = 'CLICK_UPDATE'; // 更新ボタン押下時
export const STOP_UPDATE = 'STOP_UPDATE'; // 機種名検索のフォーカス時
export const ON_BLUR = 'ON_BLUR'; // 機種名検索のフォーカスアウト
export const USER_NAME = 'USER_NAME';
export const LOGOUT = 'LOGOUT';
export const NO_DATA = 'NO_DATA'; // 空データ読み込み
export const RE_RENDER = 'RE_RENDER'; // 再描画
export const CALL_WEB_FONT_API = 'CALL_WEB_FONT_API'; // web font apiをコール
export const SELECT_KIKAN = 'SELECT_KIKAN'; // 期間選択
export const SELECT_NOHIN = 'SELECT_NOHIN'; // 納品開始日選択

export const OPEN_DATEPICKER = 'OPEN_DATEPICKER'; // 日付選択ダイアログオープン
export const CHANGE_CALENDAR_VIEW_MODE = 'CHANGE_CALENDAR_VIEW_MODE'; // カレンダー表示モード変更
export const CALENDAR_CANCEL = 'CALENDAR_CANCEL'; // カレンダーキャンセル
export const UPDATE_DISPLAY_DATE = 'UPDATE_DISPLAY_DATE'; // displayDate更新
export const UPDATE_KIKAN_TERM = 'NEWCAL_CHANGE_KIKAN_TERM'; // カレンダー期間変更
export const CHANGE_KIKAN_UNIT = 'CHANGE_KIKAN_UNIT'; // カレンダー期間単位変更
export const CHANGE_GRAPH_KIKAN_UNIT = 'CHANGE_GRAPH_KIKAN_UNIT'; // カレンダー期間単位変更(グラフ)

export const OPEN_KIKAN = 'OPEN_KIKAN'; // 期間カレンダーオープン
export const CLOSE_KIKAN = 'CLOSE_KIKAN'; // 期間カレンダークローズ
export const CLOSE_KAISHIBI = 'CLOSE_KAISHIBI'; // 納品開始日カレンダークローズ

export const FILTER_FORM_APPLY = 'FILTER_FORM_APPLY'; // 絞込条件反映イベント

export const CHANGE_PS_RATE = 'CHANGE_PS_RATE'; // PS&レート変更時
export const CHANGE_DISPLAY_ITEM = 'CHANGE_DISPLAY_ITEM'; // 表示する値変更時
export const CLICK_SEARCH_SUMMARY = 'CLICK_SEARCH_SUMMARY'; // 検索ボタン押下時
export const CLEAR_KISHU_SUMMARY = 'CLEAR_KISHU_SUMMARY'; // 更新ボタン押下時
